module.exports = __webpack_public_path__ + "img/usa.cbfe8d83.svg";